import { QueryFilters } from '@tanstack/react-query';
import { DashboardItemDto } from '@unistocks/proxy/axios-client';
import { portfoliosGetTimeSeriesQueryKey } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { getDateRange } from '@unistocks/shared/utils/date-utils';
import { isNumber } from '@unistocks/shared/utils/util';

export const queryFilter = ({ settings }: DashboardItemDto): QueryFilters | null => {
  const { portfolios, period } = settings;

  if (isNumber(period) && portfolios?.length) {
    const [start, end] = getDateRange(period).map(date => date.toISODate());

    return {
      queryKey: portfoliosGetTimeSeriesQueryKey({
        id: portfolios[0],
        start,
        end,
        includeTransactions: true
      })
    };
  }

  return null;
};
